import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const AddUserDialogStyle = (theme: Theme) =>
    createStyles({
      redMarked: {
        '& label': {
          color: styleColors.pureRed,
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: styleColors.pureRed,
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: styleColors.pureRed,
          },
        },
      },
    });



// WEBPACK FOOTER //
// ./src/components/extended-family/add-child-dialog/AddUserDialog.style.ts